import { ActionButtonProps, Box, BoxProps, ColorOptions, Form, Icon, Spacer } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import { FC, useEffect, useState } from 'react'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { ROUTING_PACKAGE_FILETYPE } from '../../utils/constants'
import { formData } from './formData'

interface PackageFormProps {
  data: any
  onSuccess: () => void
  isEditable: boolean
  isDeletable: boolean
  onClose?: () => void
  packageCategoryList?: any
}

const PackageForm: FC<PackageFormProps> = (props: PackageFormProps) => {
  const { data, onSuccess, isEditable, isDeletable, packageCategoryList } = props
  const { id } = data
  const [toggle, setToggle] = useState(false)

  const { add, update, deletePackage, message } = useStores((store) => ({
    add: store.package.add,
    update: store.package.update,
    deletePackage: store.package.deletePackage,
    message: store.message.getFormMessage(),
  }))

  const [lazyAdd, lazyAddHandler] = useLazyApiData(add)
  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(update)
  const [lazyDeletePackage, lazyDeletePackageHandler] = useLazyApiData(deletePackage)

  const onSubmit = (values: any) => {
    if (id) {
      lazyUpdate({
        id,
        group: values.group,
        category: values.category,
        fileType: ROUTING_PACKAGE_FILETYPE,
      })
    } else {
      lazyAdd({
        group: values.group,
        category: values.category?.toLowerCase(),
        fileType: ROUTING_PACKAGE_FILETYPE,
      })
    }
  }

  useEffect(() => {
    if (lazyAddHandler.state === 'fulfilled') {
      onSuccess()
    }
  }, [lazyAddHandler, onSuccess])

  useEffect(() => {
    if (lazyUpdateHandler.state === 'fulfilled') {
      onSuccess()
    }
  }, [lazyUpdateHandler, onSuccess])

  useEffect(() => {
    if (lazyDeletePackageHandler.state === 'fulfilled') {
      onSuccess()
      setToggle(false)
    }
    if (lazyDeletePackageHandler.state === 'rejected') {
      setToggle(false)
      // onSuccess()
    }
  }, [lazyDeletePackageHandler, onSuccess])

  const onDelete = () => {
    lazyDeletePackage({
      ...data,
    })
  }
  const onDismiss = () => {
    setToggle(false)
  }
  const deleteMapping = () => {
    setToggle(true)
  }

  const isLoading = () => {
    return lazyAddHandler.state === 'pending' || lazyUpdateHandler.state === 'pending'
  }

  const handleActions = ({ values, title, defaultActionButtonOnSubmit }: ActionButtonProps) => {
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box pv={16} flexDirection="row" justify={'center'} align={'center'}>
        <ModalAlertView
          onPress={onDelete}
          show={toggle}
          onDismiss={onDismiss}
          title="Delete Package"
          buttonTitle="Delete"
          message={`Is this final. This will raise request in approvals to delete routing package with package name ${data?.packageName}`}
          isLoading={lazyDeletePackageHandler.state === 'pending'}
        />
        {isEditable && (
          <Button
            title={id ? 'Update' : title}
            onPress={handleOnPress}
            isLoading={isLoading()}
            height={40}
            color={'#214796'}
          />
        )}
        <Spacer direction="horizontal" size={16} />
        {isDeletable && id && (
          <Box
            onPress={deleteMapping}
            bg="RED"
            underlayColor="ERROR"
            p={'MEDIUM'}
            justify={'center'}
            align={'center'}
            borderRadius={4}>
            <Icon id="DELETE" size={24} color="WHITE" />
          </Box>
        )}
      </Box>
    )
  }

  const FormBox = ({ children }: any) => {
    return <Box f={1}>{children}</Box>
  }

  return (
    <Box onPress={() => {}} {...styles.formContainer} overflow="auto">
      <Form
        formData={formData(onSubmit, id ? false : true, message, packageCategoryList)}
        actionButtons={handleActions}
        initialValues={id ? data : {}}
        container={FormBox}
      />
    </Box>
  )
}

export { PackageForm }

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    overflow: 'auto',
    bg: 'WHITE',
    padding: 'MEDIUM',
    backgroundColor: 'WHITE',
    minHeight: 184,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#e3e6f0' as ColorOptions,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    ...shadow,
  } as BoxProps,
}
